export default __webpack_public_path__ + "static/RunRight2-e4a7d0b7c2af3d28dfe79a90c7ade397.mp3";